export default __webpack_public_path__ + "static/media/Grades.26c1f642.svg";